import "@turf/turf";
import "./index.es175.js";
import { rgbArrayCssColor as t } from "./index.es277.js";
import "./index.es176.js";
import { getTheNextFreePaletteColors as e } from "./index.es67.js";
const i = (o) => {
  const r = e({
    mapId: o,
    category: "trade-area",
    bucket: 1
  });
  return {
    palette: r,
    color: t(r.paletteColors[0])
  };
};
export {
  i as getChainVenuesColor
};
//# sourceMappingURL=index.es256.js.map
